import JSXElement from './JSXElement.js';

export default class JSXFragment extends JSXElement {
}
